function getValidationError (error) {
  let validationError = null

  if (((error || {}).response || {}).status === 400) {
    validationError = (((error || {}).response || {}).data || {})
  }

  return validationError
}

function extractFormErrors (error) {
  let parsed = null
  const validationError = getValidationError(error)

  if (validationError) {
    parsed = validationError.errors
  }

  return parsed
}

function getErrorTitle (error) {
  let title = null
  const validationError = getValidationError(error)

  if (validationError) {
    title = validationError.title
  }

  return title
}

export { extractFormErrors, getErrorTitle }
